// @flow
import axios from 'axios';

export const setAuthorizationToken = (token: ?string) => {
  if (token) {
    // eslint-disable-next-line immutable/no-mutation
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
};



// WEBPACK FOOTER //
// ./src/utils/setAuthorizationToken.js